import React from 'react';
import { SVGProps } from './type';

export const IconVirtualCard = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M19 9.16667V8.33333C19 7.41286 18.2538 6.66667 17.3333 6.66667H7.33333C6.41286 6.66667 5.66667 7.41286 5.66667 8.33333V9.16667H19ZM19 10.8333H5.66667V15C5.66667 15.9205 6.41286 16.6667 7.33333 16.6667H17.3333C18.2538 16.6667 19 15.9205 19 15V10.8333ZM7.33333 5H17.3333C19.1743 5 20.6667 6.49238 20.6667 8.33333V15C20.6667 16.8409 19.1743 18.3333 17.3333 18.3333H7.33333C5.49238 18.3333 4 16.8409 4 15V8.33333C4 6.49238 5.49238 5 7.33333 5ZM8.16667 15C7.70643 15 7.33333 14.6269 7.33333 14.1667C7.33333 13.7064 7.70643 13.3333 8.16667 13.3333H9.83333C10.2936 13.3333 10.6667 13.7064 10.6667 14.1667C10.6667 14.6269 10.2936 15 9.83333 15H8.16667Z"
      fill={fill}
    />
  </g>
);
